"use client";

import { email, isLandauLive } from "@/lib/consts";
import { navigationItems } from "@/lib/navigationItems";
import { useMessages } from "@/lib/i18n/useMessages";
import { locationStrings } from "@/lib/strings/locationStrings";
import { Box, Stack, useTheme } from "@mui/material";
import { SLButtonWriteEmail } from "../../buttons/SLButtonWriteEmail";
import { SLCardAdress } from "../../cards/SLCardAdress";
import { SLContainer } from "../../layout/SLContainer";
import { SLHtmlFromLangFile } from "./SLHtmlFromLangFile";

export const SLHomeContact = ({
  contactRef,
  backgroundColor,
}: {
  contactRef: React.RefObject<HTMLDivElement | null>;
  backgroundColor?: string;
}) => {
  const theme = useTheme();
  const home = useMessages().home;

  return (
    <Box
      component="section"
      ref={contactRef}
      sx={{
        width: "100%",
        backgroundColor: backgroundColor || theme.palette.background.paper,
      }}
    >
      <SLContainer
        id={navigationItems.contact.id}
        title={home.contact.title}
        isTwoColumns={true}
        hasPaddingTop={true}
        subtitle={
          <Stack
            direction="column"
            gap={4}
            sx={{
              width: "100%",

              alignSelf: "center",
            }}
            pb={10}
          >
            <SLHtmlFromLangFile htmlString={home.contact.subtitle} />
            <SLButtonWriteEmail email={email.general} />
          </Stack>
        }
      >
        <Stack direction="column" gap={2}>
          {Object.values(locationStrings)
            .filter((location) =>
              isLandauLive ? true : location !== locationStrings.Landau,
            )
            .map((location) => (
              <SLCardAdress key={location.fullName} location={location} />
            ))}
        </Stack>
      </SLContainer>
    </Box>
  );
};
